<template>
  <div class="password-wrap">
    <img :src="logo" alt="" class="logo">

    <div class="password-input-wrap">
      <h1 v-if="!finished" class="title" v-t="'password.heading'"></h1>
      <span v-if="!finished" class="text" v-t="'password.text'"></span>
      <el-form
        v-if="!finished"
        :model="passwordObj"
        class="input-form"
        :rules="rules"
        ref="form">
        <el-form-item :label="$t('password.password')" prop="password">
          <el-popover
            placement="top"
            width="200"
            trigger="focus">
            <div class="password-guidelines">
              <div>
                <i v-if="!passwordHas.capitalLetter" class="el-icon-error red"></i>
                <i v-else class="el-icon-success green"></i>
                <span class="password-guideline">Großbuchstabe</span>
              </div>
              <div>
                <i v-if="!passwordHas.lowerLetter" class="el-icon-error red"></i>
                <i v-else class="el-icon-success green"></i>
                <span class="password-guideline">Kleinbuchstabe</span>
              </div>
              <div>
                <i v-if="!passwordHas.specialCharacter" class="el-icon-error red"></i>
                <i v-else class="el-icon-success green"></i>
                <span class="password-guideline">Sonderzeichen</span>
              </div>
              <div>
                <i v-if="!passwordHas.number" class="el-icon-error red"></i>
                <i v-else class="el-icon-success green"></i>
                <span class="password-guideline">Ziffer</span>
              </div>
              <div>
                <i v-if="!passwordHas.correctSize" class="el-icon-error red"></i>
                <i v-else class="el-icon-success green"></i>
                <span class="password-guideline">8 Zeichen</span>
              </div>
            </div>
            <el-input
              slot="reference"
              id="password"
              autocomplete="off"
              type="password"
              @input="onPasswordChange"
              :placeholder="$t('login.password_placeholder')"
              v-model="passwordObj.password"
              class="password-input"></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('password.passwordRepeat')" prop="passwordRepeat">
          <el-input id="password_repeat"
                    type="password"
                    :placeholder="$t('password.passwordRepeat')"
                    v-model="passwordObj.passwordRepeat"
                    class="password-input"></el-input>
        </el-form-item>
        <el-button :loading="isLoading" class="password-button" type="primary" @click="setPassword()" round>
          {{$t('password.save_password')}}
        </el-button>
      </el-form>
      <div v-if="finished" style="text-align: center">
        <h2 v-t="'password.finished'"></h2>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import {accountService} from "../../services/AccountService.class";
  import {hasCapitalLetter, hasLowerLetter, hasNumber, hasSpecialCharacter} from "../../helper/PasswordHelper";

  const authStateMappers = createNamespacedHelpers('auth');
  import mspLogo from '../../assets/msp-logo.png'

  export default {
    name: "SetPassword",
    data() {
      let checkPassword = (rule, value, callback) => {
        const passwordHas = {
          capitalLetter: hasCapitalLetter(value),
          lowerLetter: hasLowerLetter(value),
          number: hasNumber(value),
          specialCharacter: hasSpecialCharacter(value),
        };
        let numberOfCorrect = 0;
        for (var key in passwordHas) {
          if (passwordHas.hasOwnProperty(key) && passwordHas[key] !== null) {
            numberOfCorrect++;
          }
        }
        if (numberOfCorrect >= 3 && value.length >= 8) {
          callback()
        } else {
          return callback(new Error('Please use a correct password'));
        }
      };
      let comparePassword = (rule, value, callback) => {
        let otherPassword = this.passwordObj.passwordRepeat;

        if (rule.field === 'passwordRepeat') {
          otherPassword = this.passwordObj.password;
        }
        if (otherPassword && otherPassword !== value) {
          return callback(new Error('The passwords do not match'));
        }
        callback();
      };
      return {
        passwordHas: {
          capitalLetter: false,
          lowerLetter: false,
          specialCharacter: false,
          number: false,
          correctSize: false,
        },
        rules: {
          password: [
            {
              required: true,
              validator: checkPassword,
              message: this.$t('password.password_doesnt_match_guidelines'),
              trigger: ['blur', 'change', 'input']
            },
            {
              required: true,
              validator: comparePassword,
              message: this.$t('password.check_password'),
              trigger: ['blur', 'change', 'input']
            },
          ],
          passwordRepeat: [
            {
              required: true,
              validator: comparePassword,
              message: this.$t('password.check_password'),
              trigger: ['blur', 'change', 'input']
            },
          ],
        },
        logo: mspLogo,
        isLoading: false,
        passwordObj: {
          password: '',
          passwordRepeat: ''
        },
        finished: false
      }
    },
    methods: {
      ...authStateMappers.mapActions(['doLoginAction']),
      onPasswordChange(password) {
        this.$refs['form'].validate();
        if (password) {
          this.passwordHas = {
            correctSize: password.length >= 8,
            capitalLetter: hasCapitalLetter(password),
            lowerLetter: hasLowerLetter(password),
            number: hasNumber(password),
            specialCharacter: hasSpecialCharacter(password),
          }
        }
      },
      setPassword() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.passwordObj.password !== this.passwordObj.passwordRepeat) {
              return;
            }
            this.isLoading = true;
            accountService.setPassword(this.$route.params.code, this.passwordObj.password).then(() => {
              this.$notify({
                title: this.$t('password.title'),
                message: this.$t('base.passwordSetSuccess'),
                type: 'success'
              });
              this.finished = true;
            }).catch(() => {
              this.$notify.error({
                title: this.$t('password.error'),
                message: this.$t('base.passwordSetError')
              });
            }).finally(() => {
              this.isLoading = false;
            });
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .red {
    color: #f56c6c;
  }

  .green {
    color: #67c23a;
  }

  .password-guidelines {
    .password-guideline {
      margin: 0 0 0 5px;
    }
  }

  .password-wrap {
    padding: 10px;
    margin: 0 auto;
    max-width: 600px;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;

    .title {
      text-align: center;
    }

    .logo {
      max-width: 400px;

      @media only screen and (max-width: 640px) {
        max-width: 40vw;
        margin-top: 2em;
      }
    }

    .password-input-wrap {
      width: 100%;

      .text {
        max-width: 600px;
        display: inline-block;
      }

      .input-form {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 3em 0 0 0;
        position: relative;

        @media only screen and (max-width: 320px) {
          padding: 1em 0 0 0;

          .password-input {
            max-width: 300px;
          }

          .el-form-item {
            text-align: center;
          }
        }

        .el-form-item {
          width: inherit;
        }

        .password-input {
          padding: 10px 0;
        }

        .password-button {
          margin-top: 1em;
          margin-bottom: 1em;
          align-self: center;
        }
      }
    }

  }
</style>
